import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as SlideActions from "Data/slides/SlideActions";

import Button from "UI/Button";
import Dropdown from "UI/Dropdown";
import NewSlideDialog from "Components/NewSlideDialog";
import { PlusCircleIcon } from "@heroicons/react/solid";
import { ArrowDownIcon, ArrowUpIcon, TrashIcon } from "@heroicons/react/outline";
import { Menu } from '@headlessui/react'
import classNames from "classnames";

class AddSlideButton extends React.Component
{
    state = {
        adding: false
    };

    static propTypes = {
        storyId: PropTypes.string.isRequired,
        createSlide: PropTypes.func.isRequired,
        selectSlide: PropTypes.func.isRequired,
    };

    handleClickOpen = () => {
        this.setState({ adding: true });
    };

    handleClose = (slideId) => {
        this.setState({ adding: false });
        this.props.selectSlide(slideId);
    };

    render()
    {
        const classes = classNames({
            "inline-flex items-center text-gray-600": true,
            "focus:outline-none focus:ring-none focus:ring-0": true,
            "hover:text-gray-600": true
        });

        const button = ({triggerRef}) => <Dropdown.Button ref={triggerRef} className={classes} onClick={this.handleClickOpen}>
            <PlusCircleIcon className='w-4 h-4 mr-2' /> New Slide
        </Dropdown.Button>;

        // return <>
        //     { button }
        //     <NewSlideDialog
        //         storyId={this.props.storyId}
        //         open={this.state.adding}
        //         createSlide={this.props.createSlide}
        //         onClose={this.handleClose}
        //     />
        // </>;

        return <>
            <Dropdown button={button} origin='bl'>
                {
                    /*
                    <p className="text-xs font-medium tracking-wide text-gray-500 uppercase p-4 py-2">New Slide</p>
                    */
                }

                <Dropdown.Item onClick={() => this.props.createSlide(this.props.storyId).then(slide => this.props.selectSlide(slide.id))}>
                    New Blank Slide
                </Dropdown.Item>
                <Dropdown.Item onClick={this.handleClickOpen}>
                    New Template Slide
                </Dropdown.Item>
                {
                    /*
                    <p className="text-xs font-medium tracking-wide text-gray-500 uppercase p-4 py-2">New Element</p>
                    */
                }
            </Dropdown>
            <NewSlideDialog
                storyId={this.props.storyId}
                open={this.state.adding}
                createSlide={this.props.createSlide}
                onClose={this.handleClose}
            />
        </>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    alerts: state.notifications
});

const mapDispatchToProps = {
    createSlide: SlideActions.createSlide,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSlideButton);
